import Typography from '../components/Typography';
import Layout from '../components/Layout';
import Currency from 'components/Currency/Currency';
import TextInput from '../components/TextInput';
import { useNavigate } from '@reach/router';

const AmountButton = ({ amount }) => {
  return (
    <button className="cursor-pointer py-5 flex items-center justify-center bg-white rounded-[10px] border-solid border-[#E5E7EB]">
      <Typography weight="bold" className="text-[20px]">
        <Currency amount={amount} />
      </Typography>
    </button>
  );
};

const AmountSelector = () => {
  return (
    <div className="mb-24 grid grid-cols-2 gap-4">
      <AmountButton amount={2500} />
      <AmountButton amount={5000} />
      <AmountButton amount={10000} />
      <AmountButton amount={25000} />
      <TextInput center className="col-span-2" placeholder="Other amount" />
    </div>
  );
};

const AddFunds = () => {
  const navigate = useNavigate();
  return (
    <Layout className="pt-20 px-6">
      <Typography className="mb-8 text-[14px] text-center" weight="bold">
        CHOOSE AMOUNT
      </Typography>
      <Typography weight="bold" className="mb-10 text-[60px] text-center">
        $50
      </Typography>
      <AmountSelector />
      <button
        className="cz-btn-brand w-full"
        onClick={() => navigate(`/gift-redeem/message`)}
      >
        Continue
      </button>
    </Layout>
  );
};

export default AddFunds;
